import { RatingInputId } from './is-rating-input';

export const getRatingHintByInputId = (inputId: RatingInputId): string => {
    switch (inputId) {
        case 'cr_stars-selection__input--1':
            return 'Sehr schlecht';
        case 'cr_stars-selection__input--2':
            return 'Schlecht';
        case 'cr_stars-selection__input--3':
            return 'Mittelmäßig';
        case 'cr_stars-selection__input--4':
            return 'Gut';
        case 'cr_stars-selection__input--5':
            return 'Sehr gut';
    }
};
